export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="max-w-2xl mx-auto text-center">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-3">
            联系我们
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mb-8">
            意见反馈 · 资源投稿 · 商业合作
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-8">
            <div className="p-5 bg-background-100 rounded-xl border border-background-200/70">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mx-auto mb-3">
                <i className="ri-mail-line text-xl"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">意见反馈</h3>
              <p className="text-xs text-foreground-500">feedback@97cinema.com</p>
            </div>
            <div className="p-5 bg-background-100 rounded-xl border border-background-200/70">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-700 mx-auto mb-3">
                <i className="ri-upload-cloud-line text-xl"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">资源投稿</h3>
              <p className="text-xs text-foreground-500">submit@97cinema.com</p>
            </div>
            <div className="p-5 bg-background-100 rounded-xl border border-background-200/70">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-700 mx-auto mb-3">
                <i className="ri-team-line text-xl"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">商业合作</h3>
              <p className="text-xs text-foreground-500">biz@97cinema.com</p>
            </div>
          </div>

          <p className="text-xs text-foreground-500">
            我们重视每一位用户的反馈和建议，期待与你一起让追剧体验变得更好
          </p>
        </div>
      </div>
    </section>
  );
}